import { Overlay, OverlayPositionBuilder, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Directive, ElementRef, HostListener, inject, input } from '@angular/core';
import { TooltipContentComponent } from '@components/shared/tooltip-content/tooltip-content.component';

@Directive({
    selector: '[appTooltip]',
    standalone: true
})
export class TooltipOverlayDirective {
    appTooltip = input<string | undefined>(undefined);

    private overlay = inject(Overlay);
    private elementRef = inject(ElementRef);
    private positionBuilder = inject(OverlayPositionBuilder);

    private overlayRef: OverlayRef | null = null;

    @HostListener('mouseenter')
    onMouseEnter() {
        this.show();
    }

    @HostListener('mouseleave')
    onMouseLeave() {
        this.hide();
    }

    show() {
        if (!this.appTooltip() || this.overlayRef) return;

        const positionStrategy = this.positionBuilder.flexibleConnectedTo(this.elementRef).withPositions([
            {
                originX: 'center',
                originY: 'top',
                overlayX: 'center',
                overlayY: 'bottom',
                offsetY: -8
            }
        ]);

        this.overlayRef = this.overlay.create({
            positionStrategy,
            hasBackdrop: false
        });

        const tooltipPortal = new ComponentPortal(TooltipContentComponent);
        const tooltipRef = this.overlayRef.attach(tooltipPortal);

        tooltipRef.setInput('tooltipText', this.appTooltip());
    }

    hide() {
        this.overlayRef?.dispose();
        this.overlayRef = null;
    }
}
